<svg class="vector" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L7 7L1 13" stroke="var(--icon-color)" stroke-width="2.3" />
</svg>
